import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

var config = {
  apiKey: "AIzaSyDXkJ-GiHQoPRuerVizeSZtjCcJoP1Tfas",
  authDomain: "juventudesydiversidades.firebaseapp.com",
  databaseURL: "https://juventudesydiversidades.firebaseio.com",
  projectId: "juventudesydiversidades",
  storageBucket: "juventudesydiversidades.appspot.com",
  messagingSenderId: "442720131730",
  appId: "1:442720131730:web:2bb5755a487109f132644b"
}

firebase.initializeApp(config)
// firebase.analytics()

// export const google = new firebase.auth.GoogleAuthProvider()
export const auth = firebase.auth()
export const db = firebase.firestore()
export const fire = firebase
